import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'

export class ComboService extends BaseService {
  static async getListTingbox(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.request-combo.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getPlaneServiceCommbo(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.get-plan-config'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async resgisterSellPackageForCustomer(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.econtract-register-combosell'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getList(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.combo-registration-request.filter'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async addCombo(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.combo-registration-request.create'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async editCombo(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.combo-registration-request.action'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailCombo(id) {
    try {
      const response = await this.request({ auth: true }).get(
        storeHelper.getUrl('cnps.agent.combo-registration-request.detail').replace('{id}', id)
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailComboTingbox(params = []) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.request-combo.get-detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateComboStatus(params = []) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.combo-registration-request.action'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateComboStatusTingbox(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.request-combo.action'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getComboByCode(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.request-combo.get-detail-by-code'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createContract(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.save-360-combosell'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async listPackages(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.request-combo.list-package'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updatePackage(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.request-combo.update-package'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelPackage(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.request-combo.cancel-package'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async confirmPackage(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.request-combo.confirm-package'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
